import type * as StreamFallbackBundle from '@foundation-player/plugin-stream-fallback';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createStreamFallbackPlugin: PluginFactoryFunction = (builderConfig) => {
  const streamFallbackPackage = PackageName.PluginStreamFallback;

  return [
    [streamFallbackPackage],
    () => {
      const bundle = resolveByPackageNameOrThrow<typeof StreamFallbackBundle>(streamFallbackPackage);
      const streamFallbackGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[PackageName.PluginStreamFallback];
      return [
        new bundle.StreamFallbackPlugin(
          builderConfig.pluginConfigs[streamFallbackGlobalName] as StreamFallbackBundle.PluginConfig,
        ),
      ];
    },
  ];
};
